import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { ClientIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';
import useResourcesSearchHistory from 'app/components/Resources/ResourcesContent/ResourcesNLPSearch/useResourcesSearchHistory';
import { WorldGlobe } from 'app/components/shared/icons';
import useIsMobile from 'hooks/useIsMobile';
import { setPrompt } from 'store/reducers/nlp/nlp-reducer';

import {
  ResourcesStepsOneExamplesItem,
  ResourcesStepsOneExamplesItemTitle,
  ResourcesStepsOneExamplesList,
  ResourcesStepsOneExamplesTitle,
  ResourcesStepsOneExamplesWrapper,
} from './styled';

export default function ResourcesStepsOneExamples() {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { saveSearch } = useResourcesSearchHistory();

  const examples = useMemo(() => {
    return [
      {
        icon: <ClientIcon />,
        title: 'All the Fintech and Banking case studies',
      },
      {
        icon: <ClientIcon />,
        title: 'Case studies we have connected to Retail clients',
      },
      {
        icon: <WorldGlobe />,
        title: 'Decks for Sports clients',
      },
      {
        icon: <WorldGlobe />,
        title: 'kyu Pulse company credentials',
      },
      {
        icon: <WorldGlobe />,
        title: 'Show me all the AI case studies',
      },
    ];
  }, []);

  const handleExampleClick = (example: string) => {
    if (isMobile) {
      window.scrollTo(0, 0);
    }
    saveSearch(example);
    dispatch(setPrompt(example));
  };

  return (
    <ResourcesStepsOneExamplesWrapper>
      <ResourcesStepsOneExamplesTitle>TRY AN EXAMPLE</ResourcesStepsOneExamplesTitle>
      <ResourcesStepsOneExamplesList>
        {examples.map((example) => (
          <ResourcesStepsOneExamplesItem
            key={example.title}
            onClick={() => handleExampleClick(example.title)}
          >
            {React.cloneElement(example.icon, {
              width: 16,
              height: 16,
              fill: 'var(--color-primary)',
            })}
            <ResourcesStepsOneExamplesItemTitle>{example.title}</ResourcesStepsOneExamplesItemTitle>
          </ResourcesStepsOneExamplesItem>
        ))}
      </ResourcesStepsOneExamplesList>
    </ResourcesStepsOneExamplesWrapper>
  );
}
